export default Object.freeze({
    card_standard: {
        width: 2.125,
        height: 3.375,
        ratio: 0.6296296296,
        corner_radius: 0.125,
    },
    template: {
        zoom_ratio: 210,
        text_zoom_ratio: 0.5,
    },
    routes: {
        signin: '/@signin',
        signup: '/@signup',
        template: '/@template',
        templateWUsername: '/@template?username=',
    },
});
